<template>
    <span>
        <svg-icon :width="width" :height="height" :viewBox="`0 0 ${height} ${width}`" iconName="user">
            <defs>
                <path v-if="width == 18" id="u2nta966ka" d="M8 9.211c-2.984 0-5.322 1.383-5.322 3.148v.543c0 .238.193.431.431.431s.431-.193.431-.43v-.544c0-1.24 2.043-2.286 4.46-2.286s4.46 1.047 4.46 2.286v.543c0 .238.193.431.43.431.239 0 .432-.193.432-.43v-.544c0-1.765-2.338-3.148-5.322-3.148zm2.6-4.322c-.083-.557-.337-1.061-.735-1.46-.398-.398-.903-.652-1.46-.734-.253-.038-.51-.038-.764 0-1.42.21-2.404 1.538-2.194 2.958.102.688.466 1.296 1.025 1.71.454.337.991.513 1.546.513.129 0 .258-.01.388-.028 1.42-.211 2.404-1.538 2.194-2.959zM8.28 6.995c-.461.068-.92-.047-1.295-.324-.374-.277-.617-.684-.685-1.144-.141-.95.517-1.839 1.468-1.98.085-.012.17-.019.256-.019.085 0 .17.007.255.02.765.113 1.355.703 1.468 1.468.141.95-.517 1.838-1.468 1.98z"/>
                <path v-else id="1242pp3uea" d="M12 13.817c-4.476 0-7.982 2.074-7.982 4.722v.815c0 .357.289.646.646.646.357 0 .646-.29.646-.646v-.815c0-1.86 3.064-3.43 6.69-3.43 3.626 0 6.69 1.57 6.69 3.43v.815c0 .357.29.646.646.646.357 0 .646-.29.646-.646v-.815c0-2.648-3.506-4.722-7.982-4.722zm3.9-6.483c-.124-.836-.505-1.593-1.102-2.19-.597-.597-1.354-.978-2.19-1.102-.38-.056-.766-.056-1.146 0-2.13.316-3.607 2.307-3.291 4.438.153 1.032.699 1.943 1.537 2.565.68.504 1.487.77 2.319.77.193 0 .387-.015.581-.044 2.131-.316 3.608-2.306 3.292-4.437zm-3.481 3.159c-.69.102-1.38-.07-1.941-.487-.56-.416-.926-1.025-1.029-1.716-.211-1.426.777-2.758 2.203-2.97.127-.018.255-.027.383-.027s.257.01.384.028c1.147.17 2.032 1.055 2.202 2.202.212 1.426-.776 2.758-2.202 2.97z"/>
            </defs>
            <g fill="none" fill-rule="evenodd">
                <mask :id="`${id}ts1hphv3kb`" fill="#fff">
                    <use v-if="width == 18"xlink:href="#u2nta966ka"/>
                    <use v-else xlink:href="#1242pp3uea"/>
                </mask>
                <g class="path" :fill="fill" :mask="`url(#${id}ts1hphv3kb)`">
                    <path :d="`M0 0H${height}V${width}H0z`"/>
                </g>
            </g>
        </svg-icon>
    </span>
</template>

<script>
import SvgIcon from '@theme-views/common/SvgIcon'

export default {
    name: 'svg-user',
    computed: {
        fill() {
            return this.color || 'url(#linearGradient-1)'
        }
    },
    components: {
        SvgIcon
    },
    props: {
        id: {
            type: Number,
            default: 1
        },
        width: {
            type: Number,
            default: 26,
        },
        height: {
            type: Number,
            default: 26,
        },
        color: {
            type: String,
            default: null
        }
    },
}
</script>